import { parseRoute, useApp } from "../store.jsx";

export default function Header({ hash }) {
  const { auth, logout } = useApp();
  const r = parseRoute(hash);
  const isActive = (name) => {
    if (name === "home") return r.name === "home";
    if (name.startsWith("dept-")) {
      const d = name.slice(5);
      if (r.name === "dept" && r.dept === d) return true;
      if (r.name === "task") {
        // task pages highlight their department
        // We can't know the task's dept synchronously without the data; the App
        // re-renders header on hash change so this is OK to leave inactive.
      }
      return false;
    }
    if (name === "settings") return r.name === "settings";
    return false;
  };

  return (
    <header className="top">
      <a href="#/" className="brand" aria-label="NYCE AI Strategy — home">
        <img src="/nyce_logic_color_small.png" alt="nyce.logic" className="brand-logo"/>
        <span className="brand-text">AI Strategy</span>
      </a>
      <nav>
        <a href="#/"            className={isActive("home") ? "active" : ""}>Overview</a>
        <a href="#/dept/Sales"  className={isActive("dept-Sales") ? "active" : ""}>Sales</a>
        <a href="#/dept/PS"     className={isActive("dept-PS") ? "active" : ""}>PS</a>
        <a href="#/dept/PD"     className={isActive("dept-PD") ? "active" : ""}>PD</a>
        <a href="#/settings"    className={isActive("settings") ? "active" : ""}>Settings</a>
      </nav>
      <span className="right">
        Horizon: May 2026 → Dec 2027 · 29 initiatives
        {auth?.required && auth.authenticated && (
          <>
            {" · "}
            <a href="#/" onClick={(e) => { e.preventDefault(); logout(); }}>Sign out</a>
          </>
        )}
      </span>
    </header>
  );
}
